export default __webpack_public_path__ + "static/media/trolley-marker-adhoc.901bf16d.svg";